import React, { useState, useEffect, useContext } from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import "./search.css";
import { UserTypeContext } from "../../AppRoute";
import searchCandidateAdminAPI from "../../apis/searchCandidateAdminAPI";
import DataTable from '../../components/DataTable/DataTable';
import Tooltip from '@mui/material/Tooltip';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import UnauthorizedAccess from '../../components/UnauthorizedAccess/UnauthorizedAccess';

const styleSx = {
    buttonAlignForRemove: {
        padding: "32px!important",
    },
    bodyForRemove: {
        padding: "26px 24px 0px 24px!important",
        marginTop: "0px!important",
    },
    leftGrid: {
        padding: "0px !important",
        boxShadow: "0px 5px 10px 0px rgba(26, 143, 255, 0.24)",
        borderRadius: "0px 0px 0px 20px",
        height: "fit-content",
    },
    searchTopContainer: {
        backgroundColor: "#D1E8FF",
        padding: "10px 10px 30px 10px",
    },
    searchBtn: {
        backgroundColor: "#1885e6",
        color: "white",
        borderRadius: "5px",
        padding: "5px 20px",
    },
    mb10: {
        marginBottom: "10px !important",
    },
    tableGridContainer: {
        paddingTop: "0px !important",
        width: "100%",
    },
    tableContainerStyle: {
        boxShadow:
            "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
        padding: "10px",
    },
    odd: {
        background: "#F6F6F6 !important",
    },
    even: {
        background: "#ffffff !important",
    },
    profileButton: {
        color: "#fff",
        backgroundColor: "#1885e6",
        width: "70px",
        "&:hover": {
            backgroundColor: "#1885e6",
            opacity: "0.9",
        },
    },
};

const Search = () => {
    const history = useNavigate();
    const { userType } = useContext(UserTypeContext);
    const [TotalNumberOfRecords, setTotalNumberOfRecords] = useState(0);
    const [lastTestTakenon, setlastTestTakenon] = useState({ name: "Anytime" });
    const [isSearching, setIsSearching] = useState(false);
    const [dataResult1, setDataResult1] = useState([]);
    const [takeNumberOfResult, setTakeNumberOfResult] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [searchTerms, setSearchTerms] = useState([]);
    const handleSearch = async (time, searchTermsData, page, size) => {
        try {
            setIsSearching(true);
            const search = await searchCandidateAdminAPI(time, searchTermsData, page, size);
            if (search.data.length > 0) {
                search?.data?.forEach((item, i) => {
                    item["locationCity"] = JSON.parse(item.locationCity)?.name || "N/A";
                    item["locationState"] = JSON.parse(item.locationState)?.name || "N/A";
                    item["locationCountry"] = JSON.parse(item.locationCountry)?.name || "N/A";
                });
                setIsSearching(false);
                setDataResult1(search.data);
                setTotalNumberOfRecords(search.count);
            }
            else {
                setIsSearching(false);
                setDataResult1([]);
                setTotalNumberOfRecords(0);
            }
        } catch (error) {
            console.error("Error fetching search results:", error);
            setIsSearching(false);
            setDataResult1([]);
            setTotalNumberOfRecords(0);
        }
    }

    const goToAdminDashboard = () => {
        history("/admin-home");
    }

    // Dropdown Change
    const TestTakenTimeHandler = async (e, value) => {
        if (value) {
            setlastTestTakenon(value);
        }
        else {
            setlastTestTakenon({ name: "Anytime" });
        }
    }

    const handleGotoProfile = async (dataItem) => {
        window.open(`/candidate/profile/${dataItem?.id}`, "_blank")
    }

    const allTestTakenOnArr = [
        { name: "Last 24 Hours" },
        { name: "Last 7 Days" },
        { name: "Last 30 Days" },
        { name: "Anytime" }
    ]

    const filterOptions = createFilterOptions({
        matchFrom: 'start',
        stringify: (option) => option.name,
    });

    // Handle page change
    const handlePageChange = (newPage, newPageSize) => {
        setPageNumber(newPage);
        if (newPageSize && newPageSize !== takeNumberOfResult) {
            setTakeNumberOfResult(newPageSize);
        }
    }

    // Handle page size change
    const handlePageSizeChange = (newPageSize) => {
        setTakeNumberOfResult(newPageSize);
        setPageNumber(1);
    };

    const handleFilterChange = (filters) => {
        let updatedFilters = []
        filters.forEach((filter) => {
            let filterObj = {
                field: filter.id,
                operator: "contains",
                value: filter.value
            };
            updatedFilters.push(filterObj);
        })
        setPageNumber(1);
        setSearchTerms(updatedFilters);
    }

    let columns = [
        {
            id: "action",
            header: "Action",
            cell: ({ row }) => (
                <>
                    <Button
                        size="small"
                        variant="contained"
                        sx={styleSx.profileButton}
                        onClick={(e) => handleGotoProfile(row.original)}
                    >
                        Profile
                    </Button>
                </>
            ),
            size: 100,
            enableSorting: false,
            enableColumnFilter: false,
        },
        {
            accessorKey: "firstName",
            header: "First Name",
            size: 200,
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            accessorKey: "lastName",
            header: "Last Name",
            size: 200,
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            accessorKey: "email",
            header: "Email",
            size: 250,
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            accessorKey: "phoneNumber",
            header: "Phone Number",
            size: 200,
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            accessorKey: "name",
            header: "Skill",
            size: 200,
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            accessorKey: "locationCity",
            header: "City",
            size: 200,
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            accessorKey: "locationState",
            header: "State",
            size: 200,
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            accessorKey: "locationCountry",
            header: "Country",
            size: 200,
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            accessorKey: "percentage",
            header: "Test Score %",
            size: 150,
            enableColumnFilter: true,
            enableSorting: false,
        }
    ]

    useEffect(() => {
        setIsSearching(true);
        const timeoutId = setTimeout(() => {
            handleSearch(lastTestTakenon?.name, searchTerms, pageNumber, takeNumberOfResult);
        }, searchTerms.length > 0 ? 1500 : 0);

        return () => clearTimeout(timeoutId);
    }, [pageNumber, takeNumberOfResult, lastTestTakenon, searchTerms]);


    return (
        <>
            <div className='main_container_search'>
                {userType === "Admin" ? (
                    <>
                        <div className='topContainer-search-candidates'>
                            <div className="communityHeader_search-candidates">
                                <div className="goBackButton" onClick={(e) => goToAdminDashboard()}>
                                    <Tooltip title="Go Back to Dashboard" placement="bottom">
                                        <ArrowBackIcon sx={{ fontSize: 20 }} />
                                    </Tooltip>
                                </div>
                                <div className="communityTitle">Search Candidates</div>
                            </div>
                            <div className='timeTakenOnContainer'>
                                <span className='timeTakenOnLabel'>
                                    Last Test Taken On
                                </span>
                                <Autocomplete
                                    id="test-taken-time-autocomplete"
                                    className='timeTakenOn'
                                    filterOptions={filterOptions}
                                    options={allTestTakenOnArr}
                                    getOptionLabel={(option) => option.name || ""}
                                    value={lastTestTakenon}
                                    onChange={TestTakenTimeHandler}
                                    getOptionSelected={(option, value) => option.name === value.name || true}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            placeholder="Select Time"
                                            size="small"
                                        />
                                    )}

                                />
                            </div>
                        </div>
                        <DataTable
                            columns={columns}
                            data={dataResult1}
                            isLoading={isSearching}
                            totalRecords={TotalNumberOfRecords}
                            currentPage={pageNumber}
                            pageSize={takeNumberOfResult}
                            onPageChange={handlePageChange}
                            onPageSizeChange={handlePageSizeChange}
                            onFilterChange={handleFilterChange}
                            enablePagination={true}
                            className='searchCandidateTable'
                            enableSorting={false}
                            pageSizeOptions={[10, 20, 50, 100]}
                            isServerSide={true}
                            noDataText="No results found !"
                        />
                    </>
                ) : (
                    <UnauthorizedAccess />
                )
                }
            </div>
        </>

    )
}

export default Search;